import Team2 from './Team2'
export default Team2
